module.exports = __webpack_public_path__ + "static/media/logo-biblioteca.00310346.svg";